import Preview from 'builder/components/Preview'
import Icon from 'builder/components/Icon'
import { DocumentTypes } from 'builder/modules/constants'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { useDocumentPreview } from '../../hooks/useDocumentPreview'
import {
  Content,
  ContentInner,
  PreviewBox,
  Pagination,
  PaginationPrev,
  PaginationCounter,
  PaginationNext,
} from './styles'

interface Props {
  forceLoadingState?: boolean
  paginationBottomPosition?: string | null
}

export const DocumentPreview = ({ forceLoadingState, paginationBottomPosition }: Props) => {
  const {
    currentPageNumber,
    totalPageNumber,
    hasPreviousPage,
    hasNextPage,
    handlePreviousPageClick,
    handleNextPageClick,
    resume,
    handlePaginationStateChange,
    dimensions,
    previewRef,
    previewBoxRef,
    contentRef,
  } = useDocumentPreview()

  const { isTablet } = useMediaQueries()

  return (
    <Content>
      <ContentInner ref={contentRef}>
        <PreviewBox ref={previewBoxRef}>
          {resume && (
            <Preview
              width={dimensions.width}
              height={dimensions.height}
              type={DocumentTypes.resume}
              document={resume}
              documentId={resume && resume.id}
              ref={previewRef}
              onPaginationChange={handlePaginationStateChange}
              forceLoadingState={forceLoadingState}
            />
          )}
        </PreviewBox>
      </ContentInner>
      {totalPageNumber >= 1 && (
        <Pagination
          style={
            paginationBottomPosition && isTablet
              ? { bottom: paginationBottomPosition, top: 'unset' }
              : undefined
          }
        >
          <PaginationPrev onClick={handlePreviousPageClick} isDisabled={!hasPreviousPage}>
            <Icon.Chevron />
          </PaginationPrev>
          <PaginationCounter>
            {currentPageNumber} / {totalPageNumber}
          </PaginationCounter>
          <PaginationNext onClick={handleNextPageClick} isDisabled={!hasNextPage}>
            <Icon.Chevron />
          </PaginationNext>
        </Pagination>
      )}
    </Content>
  )
}
